import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleQuoteBlock = ({
    quote,
    author,
    size
}) => {

    return (
        <div className='layout-container relative bg-white sm:flex my-40 md:my-60'>
            <div className='quote-spacer' />
            <div className={`sm:w-8/12 ${size === 'medium' ? 'md:w-5/12' : 'md:w-7/12'} module-quote sm:pl-10 md:pl-15`}>
                {quote && (
                    <blockquote className={`${size === 'medium' ? 'type-style-2' : 'type-style-1'} pb-20`}>{quote}</blockquote>
                )}
                {author && (
                    <figcaption className='type-style-4'>
                        <span className='pr-10'>{author}</span>
                    </figcaption>
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    quote: PropTypes.string,
    author: PropTypes.string,
    size: PropTypes.string,
};


ModuleQuoteBlock.propTypes = propTypes;

export default ModuleQuoteBlock;
